import { UseMutationResult, UseMutationOptions, useMutation } from 'react-query';
import { useDispatch } from 'react-redux';

import axios, { AxiosError } from 'axios';
import { useEffectOnce } from 'usehooks-ts';

import { resetState } from '../../store/slices/user';
import axiosInstance from '../scripts/axios';
import toast from '../scripts/toast';

export type Variables = {
  sessionKey: string;
};

type UseSessionMutationProps = {
  options?: UseMutationOptions<unknown, AxiosError<Error>, Variables>;
};

export default function useSessionMutation({
  options
}: UseSessionMutationProps): UseMutationResult<unknown, AxiosError<Error>, Variables> {
  const source = axios.CancelToken.source();

  const dispatch = useDispatch();

  const mutation = useMutation(
    async (variables) => {
      const { data } = await axiosInstance.get<void>(`/getPlayerInfoBySessionKey`, {
        params: {
          sessionKey: variables.sessionKey
        },
        cancelToken: source.token
      });

      return data;
    },
    {
      ...options,
      mutationKey: 'session_mutation',
      onError: (error, variables, context) => {
        console.error(error);

        dispatch(resetState());

        toast.error({ title: 'Oh no! 😞', message: 'Session expired!' });

        if (options?.onError) {
          options.onError(error, variables, context);
        }
      }
    }
  );

  useEffectOnce(() => {
    return () => source.cancel();
  });

  return mutation;
}
